import React from "react";
import { useState, useEffect } from "react";
import { BASE_URL, graphTypeData } from "../../constant";
import axios from "axios";
import { toast } from "react-toastify";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import BtnLoader from "../BtnLoader";
import { ColorPicker } from "@progress/kendo-react-inputs";
import { Trans, useTranslation } from "react-i18next";

function DetailsSensorConfigure({
  parametersList,
  setPopup,
  detailsPreference,
  setDetailsPreference,
  configType,
  devicelist,
  assetId,
  assets,
  darkMode,
}) {
  const { t } = useTranslation();
  const [parameters, setParameters] = useState(parametersList);
  const [loading, setLoading] = useState({
    allAssetBtn: false,
    singleAssetBtn: false,
  });
  const [checked, setChecked] = useState(false);
  const [selectedParameter, setSelectedParameter] = useState(null);

  const handleParameterClick = (parameter) => {
    const selectedCount = parameters.filter((x) => x.selected).length;
    if (
      parameter.selected ||
      (configType === "graphConfiguration" && selectedCount >= 4)
    ) {
      setParameters((pre) =>
        pre.map((s) => ({
          ...s,
          selected: s.id === parameter.id ? false : s.selected,
        }))
      );
      if (configType === "graphConfiguration") setSelectedParameter(null);
    } else {
      setParameters((pre) =>
        pre.map((s) => ({
          ...s,
          selected: s.id === parameter.id ? true : s.selected,
        }))
      );
      if (configType === "graphConfiguration")
        setSelectedParameter(parameter.id);
    }
  };

  const onGraphTypeChange = (e, id) => {
    setParameters((pre) =>
      pre.map((p) => (p.id === id ? { ...p, graphType: e.value } : p))
    );
  };

  const onGraphRangeChange = (e, id) => {
    setParameters((pre) =>
      pre.map((p) =>
        p.id === id
          ? {
              ...p,
              graphRange: { ...p.graphRange, [e.target.name]: e.target.value },
            }
          : p
      )
    );
  };

  const onCheckboxChange = () => {
    setChecked(!checked);
  };

  const onPointCheckChange = (e, id) => {
    setParameters((pre) =>
      pre.map((p) => (p.id === id ? { ...p, showPoints: e.target.checked } : p))
    );
  };

  const onCloseClick = (e) => {
    setPopup();
  };

  const onColourChange = (e, id) => {
    setParameters((pre) =>
      pre.map((p) => (p.id === id ? { ...p, pointColour: e.value } : p))
    );
  };

  const onAllAssetImport = async () => {
    setLoading({ allAssetBtn: true, singleAssetBtn: false });
    let assetConfig;
    assetConfig =
      configType === "detailsConfiguration"
        ? assets.map((x) => ({
            assetId: x.id,
            assetType: x.assetType,
            parameters: parameters
              .filter((ap) => ap.selected)
              .map((ap) => ({
                id: ap.id,
                orderIndex: ap.orderIndex,
              })),
          }))
        : assets.map((x) => ({
            assetId: x.id,
            assetType: x.assetType,
            parameters: parameters
              .filter((ap) => ap.selected)
              .map((ap) => ({
                id: ap.id,
                pointColour: ap?.pointColour || "white",
                graphType: ap?.graphType?.id || "line",
                showPoints: ap?.showPoints,
                graphRange: {
                  min: ap.graphRange?.min ? parseInt(ap.graphRange?.min) : 0,
                  max: ap.graphRange?.max ? parseInt(ap.graphRange?.max) : 100,
                },
              })),
          }));
    const value = {
      ...detailsPreference,
      assetDetails: {
        ...detailsPreference.assetDetails,
        [configType]:
          configType === "detailsConfiguration"
            ? {
                assetParameters: assetConfig,
                showLinkedDevice: checked,
              }
            : configType === "graphConfiguration" && {
                assetParameters: assetConfig,
              },
      },
    };
    try {
      const res = await axios.post(`${BASE_URL}/api/UserConfiguration`, value);
      if (res.status === 200) {
        setDetailsPreference((pre) => ({
          ...pre,
          assetDetails: res.data.assetDetails,
        }));
        setPopup();
      } else toast.error("An error occured");
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
      else toast.error("An error occured");
    }
    setLoading({ allAssetBtn: false, singleAssetBtn: false });
  };

  const onSingleAssetImport = async () => {
    setLoading({ allAssetBtn: false, singleAssetBtn: true });
    const excistingParameters =
      (detailsPreference?.assetDetails &&
        detailsPreference.assetDetails[configType]?.assetParameters) ||
      [];
    const value = {
      ...detailsPreference,
      assetDetails: {
        ...detailsPreference.assetDetails,
        [configType]:
          configType === "detailsConfiguration"
            ? {
                assetParameters: [
                  ...excistingParameters.filter((x) => x.assetId !== assetId),
                  {
                    assetId: assetId,
                    assetType: assets.find((x) => x.id === assetId)?.assetType,
                    parameters: parameters
                      .filter((ap) => ap.selected)
                      .map((ap) => ({
                        id: ap.id,
                        orderIndex: ap.orderIndex,
                      })),
                  },
                ],
                showLinkedDevice: checked,
              }
            : configType === "graphConfiguration" && {
                assetParameters: [
                  ...excistingParameters.filter((x) => x.assetId !== assetId),
                  {
                    assetId: assetId,
                    assetType: assets.find((x) => x.id === assetId)?.assetType,
                    parameters: parameters
                      .filter((ap) => ap.selected)
                      .map((ap) => ({
                        id: ap.id,
                        pointColour: ap?.pointColour || "white",
                        graphType: ap?.graphType?.id || "line",
                        showPoints: ap?.showPoints,
                        graphRange: {
                          min: ap?.graphRange?.min
                            ? parseInt(ap.graphRange.min)
                            : 0,
                          max: ap?.graphRange?.max
                            ? parseInt(ap.graphRange.max)
                            : 100,
                        },
                      })),
                  },
                ],
              },
      },
    };
    try {
      const res = await axios.post(`${BASE_URL}/api/UserConfiguration`, value);
      if (res.status === 200) {
        setDetailsPreference((pre) => ({
          ...pre,
          assetDetails: res.data.assetDetails,
        }));
        setPopup();
      } else toast.error("An error occured");
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
      else toast.error("An error occured");
    }
    setLoading({ allAssetBtn: false, singleAssetBtn: false });
  };

  const handleResetConfirmation = () => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <div className="popup w-64 p-2 rounded bg-neutral-900 shadow bg-gradient-to-b ">
          <p className="text-lg font-semibold text-slate-300 mb-2">Confirm</p>
          <p className="text-sm font-semibold text-slate-300">
            You are about to reset your configuration. Do you wish to continue?
          </p>
          <div className="flex justify-end text-sm font-medium gap-3 mt-4">
            <button
              onClick={async () => {
                onClose();
                await resetConfiguration();
              }}
              className="px-3 py-1 bg-purple-700 text-slate-300 rounded-lg"
            >
              Yes
            </button>
            <button
              onClick={onClose}
              className="px-3 py-1 bg-white text-black rounded-lg"
            >
              No
            </button>
          </div>
        </div>
      ),
    });
  };

  const resetConfiguration = async () => {
    try {
      const value = {
        ...detailsPreference,
        assetDetails: {
          ...detailsPreference.assetDetails,
          [configType]: null,
        },
      };

      const res = await axios.post(`${BASE_URL}/api/UserConfiguration`, value);

      if (res.status === 200) {
        setDetailsPreference(value);
        toast.success(`${configType} Configuration reset successfully!`);
      } else {
        toast.error("An error occurred while resetting the configuration.");
      }
    } catch (error) {
      toast.error("An error occurred while resetting the configuration.");
    }
  };

  const returnParam = (id) => {
    const param = parameters.find((p) => p.id === id);
    return param;
  };

  useEffect(() => {
    let config = detailsPreference.assetDetails?.[configType];
    if (config) {
      const asssetParams = config.assetParameters.find(
        (x) => x.assetId === assetId
      );
      if (asssetParams) {
        if (configType === "graphConfiguration") {
          const defaultGraphType = { id: "line", name: "Line" };
          const defaultGraphRange = { min: 0, max: 100 };
          const params = parameters.map((a) => {
            const param = asssetParams.parameters.find(
              (obj) => a.id === obj.id
            );
            return {
              ...a,
              graphType: param
                ? graphTypeData.find((gtd) => gtd.id === param.graphType)
                : defaultGraphType,
              graphRange: param?.graphRange || defaultGraphRange,
              pointColour: param?.pointColour || "white",
              showPoints: param?.showPoints,
              selected: !!param,
            };
          });
          setParameters(params);
        }

        if (configType === "detailsConfiguration") {
          const params = parameters.map((a, i) => ({
            ...a,
            selected: asssetParams?.parameters?.some((obj) => a.id === obj.id),
            orderIndex: asssetParams?.parameters?.find((obj) => a.id === obj.id)
              ?.orderIndex,
            index: i,
          }));

          setChecked(config?.showLinkedDevice);
          setParameters(params);
        }
      }
    }
  }, []);

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("text/plain", index);
  };

  // Function to handle drag over
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Function to handle drop
  const handleDrop = (e, index) => {
    setParameters((pre) => {
      const draggedItemIndex = parseInt(e.dataTransfer.getData("text/plain"));
      const updatedItems = [
        ...pre
          .filter((x) => x.selected)
          .sort((a, b) => a.orderIndex - b.orderIndex),
      ];
      const draggedItem = updatedItems[draggedItemIndex];
      updatedItems.splice(draggedItemIndex, 1);
      updatedItems.splice(index, 0, draggedItem);
      return pre.map((item, i) => ({
        ...item,
        orderIndex: updatedItems.findIndex((el) => el.id === item.id),
      }));
    });
  };

  return (
    <div className="relative flex flex-col dark:text-white text-lightModePopupTxt px-5 pt-5 pb-3 dark:bg-neutral-900 bg-lightModePopup w-[60vw] h-[75vh] rounded-md">
      <div className="flex justify-between items-start">
        <div>
          {configType === "detailsConfiguration"
            ? t("assetDetails.configPopup.detailsConfigHeaderText")
            : configType === "graphConfiguration" &&
              t("assetDetails.configPopup.graphConfigHeaderText")}
        </div>
        <div>
          <button type="button" onClick={onCloseClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="flex items-start justify-between mt-3 mb-2">
        <label>{t("assetDetails.configPopup.availableValues")}</label>

        {configType === "detailsConfiguration" && (
          <div className="flex gap-2 text-sm items-center font-medium">
            <input
              name="active"
              type="checkbox"
              className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded mt-1"
              id="inlineCheckbox1"
              onChange={onCheckboxChange}
              checked={checked}
              value={checked}
            ></input>
            <label>{t("assetDetails.configPopup.showLinkedDevice")}</label>
          </div>
        )}
      </div>
      <div className=" overflow-y-auto h-1/2">
        <div className="grid grid-cols-4 gap-x-5 gap-y-3 mb-4 mt-1 px-3">
          {parameters
            .sort((a, b) => a.index - b.index)
            .map(
              (pdata) =>
                pdata.enabled && (
                  <button
                    type="button"
                    key={pdata.id}
                    className={`flex justify-center w-full rounded-lg items-center disabled:opacity-50`}
                    onClick={() => handleParameterClick(pdata)}
                  >
                    <div
                      className={`flex justify-start w-full h-full py-3 gap-2 rounded-lg items-center pl-3 pr-1 
                        ${
                          pdata.selected
                            ? "bg-blue-500"
                            : "dark:bg-gray-900 bg-lightModePopupBtn hover:bg-cyan-600"
                        }`}
                    >
                      <img
                        src="Sensorlogo.svg"
                        alt="sensorLogo"
                        className="w-4 "
                      />
                      <div className="font-normal text-xs flex flex-col text-start">
                        {pdata?.name}
                        {checked && (
                          <label className="text-xxs text-slate-200">
                            {devicelist &&
                              devicelist.find(
                                (dl) => dl.device.id === pdata?.deviceId
                              )?.device.name}
                          </label>
                        )}
                      </div>
                    </div>
                  </button>
                )
            )}
        </div>
      </div>
      <label className="pt-5 pb-2">
        {t("assetDetails.configPopup.selectedValues")}
      </label>
      <div className=" overflow-y-auto h-1/3">
        {configType === "detailsConfiguration" && (
          <div className="grid grid-cols-4 gap-x-5 gap-y-3 mb-4 mt-1 px-3">
            {parameters
              .filter((x) => x.selected)
              .sort((a, b) => a.orderIndex - b.orderIndex)
              .map((x, index) =>
                x.selected && x.enabled ? (
                  <div
                    key={x.id}
                    className={`flex justify-start w-full h-full py-3 gap-2 rounded-lg items-center pl-3 pr-1 bg-blue-500`}
                    // onClick={() => handleParameterClick(pdata)}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, index)}
                  >
                    <img
                      src="Sensorlogo.svg"
                      alt="sensorLogo"
                      className="w-4 "
                    />
                    <div className="font-normal text-xs flex flex-col text-start">
                      {x?.name}
                      {/* {checked && (
                      <label className="text-xxs text-slate-200">
                        {devicelist &&
                          devicelist.find(
                            (dl) => dl.device.id === pdata?.deviceId
                          )?.device.name}
                      </label>
                    )} */}
                    </div>
                  </div>
                ) : null
              )}
          </div>
        )}
      </div>
      {selectedParameter ? (
        <div className=" overflow-y-auto mb-12 h-1/2">
          <div className="flex justify-start gap-2 items-start mt-2 mb-3">
            <Trans
              i18nKey="assetDetails.configPopup.configGraph.headerText"
              values={{ name: returnParam(selectedParameter)?.name }}
              name={returnParam(selectedParameter)?.name}
              className="flex"
            >
              {t("assetDetails.configPopup.configGraph.headerText")}
            </Trans>
          </div>
          <div className="grid grid-cols-2 justify-start w-full py-3 gap-3 rounded-lg pl-3 pr-6">
            <div className="flex justify-between">
              <label className="w-20 text-sm">
                {t("assetDetails.configPopup.configGraph.graphType")}
              </label>
              <div
                className={`w-40 lg:w-48 h-9 ${
                  darkMode ? "darkCombo" : "lightCombo"
                }`}
              >
                <ComboBox
                  data={graphTypeData}
                  textField="name"
                  dataItemKey="id"
                  value={
                    returnParam(selectedParameter)?.graphType || {
                      id: "line",
                      name: "Line",
                    }
                  }
                  className="block placeholder:text-white border-grey-light rounded-lg bg-[#363945] text-white px-5 w-full h-full"
                  onChange={(e) => onGraphTypeChange(e, selectedParameter)}
                />
              </div>
            </div>
            <div className="flex gap-5">
              <div className="flex w-1/3 gap-3">
                <label className="w-fit text-sm">
                  {t("assetDetails.configPopup.configGraph.showPoints")}
                </label>
                <div className="h-9">
                  <input
                    type="checkbox"
                    className="w-full rounded-lg"
                    value={returnParam(selectedParameter)?.showPoints}
                    checked={returnParam(selectedParameter)?.showPoints}
                    onChange={(e) => onPointCheckChange(e, selectedParameter)}
                  />
                </div>
              </div>
              <div className="flex w-2/3 justify-between">
                <label className="w-fit text-sm">
                  {t("assetDetails.configPopup.configGraph.lineColor")}
                </label>
                <div className="w-28 lg:w-36 h-7 colorInput" id="colorInput">
                  <ColorPicker
                    view="gradient"
                    id="colorInput"
                    popupSettings={{ backgroundColor: "rgb(229,231,235)" }}
                    // className="colorInput p-0 h-full w-full bg-white border border-gray-200 cursor-pointer rounded-lg"
                    value={
                      returnParam(selectedParameter)?.pointColour || "white"
                    }
                    // open={true}
                    onChange={(e) => onColourChange(e, selectedParameter)}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-between">
              <label className="w-12 text-sm">
                {t("assetDetails.configPopup.configGraph.min")}
              </label>
              <div>
                <input
                  type="number"
                  className="block placeholder:text-white border-grey-light rounded-lg bg-[#363945] text-white px-5 w-40 lg:w-48 h-9"
                  name="min"
                  value={returnParam(selectedParameter)?.graphRange?.min || 0}
                  onChange={(e) => onGraphRangeChange(e, selectedParameter)}
                />
              </div>
            </div>
            <div className="flex justify-between">
              <label className="w-12 text-sm">
                {t("assetDetails.configPopup.configGraph.max")}
              </label>
              <div>
                <input
                  type="number"
                  className="block placeholder:text-white border-grey-light rounded-lg bg-[#363945] text-white px-5 w-40 lg:w-48 h-9"
                  name="max"
                  value={returnParam(selectedParameter)?.graphRange?.max || 100}
                  onChange={(e) => onGraphRangeChange(e, selectedParameter)}
                />
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {configType === "graphConfiguration" && (
        <div className="flex absolute bottom-4 gap-1 text-xs justify-start items-center mt-3">
          <span className=" text-red-600 mr-2">!</span>{" "}
          <Trans i18nKey="assetDetails.configPopup.configGraph.warningText">
            {t("assetDetails.configPopup.configGraph.warningText")}
          </Trans>
        </div>
      )}
      <div className="flex pt-3 mb-1 text-xs right-10 justify-end gap-2 w-full">
        <button
          type="button"
          onClick={handleResetConfirmation}
          className="px-3 py-1 bg-red-600 text-slate-300 rounded-2xl ml-2"
        >
          {t("button.resetConfiguration")}
        </button>
        <button
          type="button"
          className=" bg-white text-black h-8 rounded-4xl text-center w-24"
          onClick={onCloseClick}
        >
          {t("button.cancel")}
        </button>
        <button
          type="button"
          className=" bg-indigo-700 flex gap-2 justify-center items-center rounded-4xl w-fit px-3 h-8 disabled:opacity-40"
          onClick={onSingleAssetImport}
          disabled={loading.allAssetBtn || loading.singleAssetBtn}
        >
          {t("button.applyonlythisAsset")}
          {loading.singleAssetBtn && <BtnLoader />}
        </button>
        <button
          type="button"
          onClick={onAllAssetImport}
          disabled={loading.allAssetBtn || loading.singleAssetBtn}
          className=" bg-indigo-700 flex gap-2 justify-center items-center rounded-4xl w-fit px-3 h-8 disabled:opacity-40"
        >
          {t("button.applyonallAssets")}
          {loading.allAssetBtn && <BtnLoader />}
        </button>
      </div>
    </div>
  );
}

export default DetailsSensorConfigure;
